import styled from "styled-components";

export const FormWrapper = styled.div`
  > form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 16px;
  border-top: 1px solid #d9d9d9;
  padding-top: 16px;

  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
